/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutUeberUnsImport } from './routes/_layout/ueber-uns'
import { Route as LayoutSucheImport } from './routes/_layout/suche'
import { Route as LayoutKontaktImport } from './routes/_layout/kontakt'
import { Route as LayoutInserateImport } from './routes/_layout/inserate'
import { Route as LayoutImpressumImport } from './routes/_layout/impressum'
import { Route as LayoutDatenschutzImport } from './routes/_layout/datenschutz'
import { Route as LayoutAboImport } from './routes/_layout/abo'
import { Route as LayoutSlugImport } from './routes/_layout/$slug'
import { Route as LayoutNewsletterIndexImport } from './routes/_layout/newsletter/index'
import { Route as LayoutNewsletterVerifikationImport } from './routes/_layout/newsletter/verifikation'
import { Route as LayoutNewsletterAbmeldenImport } from './routes/_layout/newsletter/abmelden'
import { Route as LayoutAutorAuthorIdImport } from './routes/_layout/autor/$authorId'
import { Route as LayoutDIdClassicIdImport } from './routes/_layout/d/id/$classicId'
import { Route as LayoutDIdClassicIdTTitleImport } from './routes/_layout/d/id/$classicId/t.$title'

// Create/Update Routes

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUeberUnsRoute = LayoutUeberUnsImport.update({
  id: '/ueber-uns',
  path: '/ueber-uns',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSucheRoute = LayoutSucheImport.update({
  id: '/suche',
  path: '/suche',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutKontaktRoute = LayoutKontaktImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutInserateRoute = LayoutInserateImport.update({
  id: '/inserate',
  path: '/inserate',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutImpressumRoute = LayoutImpressumImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDatenschutzRoute = LayoutDatenschutzImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAboRoute = LayoutAboImport.update({
  id: '/abo',
  path: '/abo',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSlugRoute = LayoutSlugImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutNewsletterIndexRoute = LayoutNewsletterIndexImport.update({
  id: '/newsletter/',
  path: '/newsletter/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutNewsletterVerifikationRoute =
  LayoutNewsletterVerifikationImport.update({
    id: '/newsletter/verifikation',
    path: '/newsletter/verifikation',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutNewsletterAbmeldenRoute = LayoutNewsletterAbmeldenImport.update({
  id: '/newsletter/abmelden',
  path: '/newsletter/abmelden',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAutorAuthorIdRoute = LayoutAutorAuthorIdImport.update({
  id: '/autor/$authorId',
  path: '/autor/$authorId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDIdClassicIdRoute = LayoutDIdClassicIdImport.update({
  id: '/d/id/$classicId',
  path: '/d/id/$classicId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDIdClassicIdTTitleRoute = LayoutDIdClassicIdTTitleImport.update({
  id: '/t/$title',
  path: '/t/$title',
  getParentRoute: () => LayoutDIdClassicIdRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/_layout/$slug': {
      id: '/_layout/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof LayoutSlugImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/abo': {
      id: '/_layout/abo'
      path: '/abo'
      fullPath: '/abo'
      preLoaderRoute: typeof LayoutAboImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/datenschutz': {
      id: '/_layout/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof LayoutDatenschutzImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/impressum': {
      id: '/_layout/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof LayoutImpressumImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/inserate': {
      id: '/_layout/inserate'
      path: '/inserate'
      fullPath: '/inserate'
      preLoaderRoute: typeof LayoutInserateImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/kontakt': {
      id: '/_layout/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof LayoutKontaktImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/suche': {
      id: '/_layout/suche'
      path: '/suche'
      fullPath: '/suche'
      preLoaderRoute: typeof LayoutSucheImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/ueber-uns': {
      id: '/_layout/ueber-uns'
      path: '/ueber-uns'
      fullPath: '/ueber-uns'
      preLoaderRoute: typeof LayoutUeberUnsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/autor/$authorId': {
      id: '/_layout/autor/$authorId'
      path: '/autor/$authorId'
      fullPath: '/autor/$authorId'
      preLoaderRoute: typeof LayoutAutorAuthorIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/newsletter/abmelden': {
      id: '/_layout/newsletter/abmelden'
      path: '/newsletter/abmelden'
      fullPath: '/newsletter/abmelden'
      preLoaderRoute: typeof LayoutNewsletterAbmeldenImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/newsletter/verifikation': {
      id: '/_layout/newsletter/verifikation'
      path: '/newsletter/verifikation'
      fullPath: '/newsletter/verifikation'
      preLoaderRoute: typeof LayoutNewsletterVerifikationImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/newsletter/': {
      id: '/_layout/newsletter/'
      path: '/newsletter'
      fullPath: '/newsletter'
      preLoaderRoute: typeof LayoutNewsletterIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/d/id/$classicId': {
      id: '/_layout/d/id/$classicId'
      path: '/d/id/$classicId'
      fullPath: '/d/id/$classicId'
      preLoaderRoute: typeof LayoutDIdClassicIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/d/id/$classicId/t/$title': {
      id: '/_layout/d/id/$classicId/t/$title'
      path: '/t/$title'
      fullPath: '/d/id/$classicId/t/$title'
      preLoaderRoute: typeof LayoutDIdClassicIdTTitleImport
      parentRoute: typeof LayoutDIdClassicIdImport
    }
  }
}

// Create and export the route tree

interface LayoutDIdClassicIdRouteChildren {
  LayoutDIdClassicIdTTitleRoute: typeof LayoutDIdClassicIdTTitleRoute
}

const LayoutDIdClassicIdRouteChildren: LayoutDIdClassicIdRouteChildren = {
  LayoutDIdClassicIdTTitleRoute: LayoutDIdClassicIdTTitleRoute,
}

const LayoutDIdClassicIdRouteWithChildren =
  LayoutDIdClassicIdRoute._addFileChildren(LayoutDIdClassicIdRouteChildren)

interface LayoutRouteChildren {
  LayoutSlugRoute: typeof LayoutSlugRoute
  LayoutAboRoute: typeof LayoutAboRoute
  LayoutDatenschutzRoute: typeof LayoutDatenschutzRoute
  LayoutImpressumRoute: typeof LayoutImpressumRoute
  LayoutInserateRoute: typeof LayoutInserateRoute
  LayoutKontaktRoute: typeof LayoutKontaktRoute
  LayoutSucheRoute: typeof LayoutSucheRoute
  LayoutUeberUnsRoute: typeof LayoutUeberUnsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutAutorAuthorIdRoute: typeof LayoutAutorAuthorIdRoute
  LayoutNewsletterAbmeldenRoute: typeof LayoutNewsletterAbmeldenRoute
  LayoutNewsletterVerifikationRoute: typeof LayoutNewsletterVerifikationRoute
  LayoutNewsletterIndexRoute: typeof LayoutNewsletterIndexRoute
  LayoutDIdClassicIdRoute: typeof LayoutDIdClassicIdRouteWithChildren
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutSlugRoute: LayoutSlugRoute,
  LayoutAboRoute: LayoutAboRoute,
  LayoutDatenschutzRoute: LayoutDatenschutzRoute,
  LayoutImpressumRoute: LayoutImpressumRoute,
  LayoutInserateRoute: LayoutInserateRoute,
  LayoutKontaktRoute: LayoutKontaktRoute,
  LayoutSucheRoute: LayoutSucheRoute,
  LayoutUeberUnsRoute: LayoutUeberUnsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutAutorAuthorIdRoute: LayoutAutorAuthorIdRoute,
  LayoutNewsletterAbmeldenRoute: LayoutNewsletterAbmeldenRoute,
  LayoutNewsletterVerifikationRoute: LayoutNewsletterVerifikationRoute,
  LayoutNewsletterIndexRoute: LayoutNewsletterIndexRoute,
  LayoutDIdClassicIdRoute: LayoutDIdClassicIdRouteWithChildren,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof LayoutRouteWithChildren
  '/$slug': typeof LayoutSlugRoute
  '/abo': typeof LayoutAboRoute
  '/datenschutz': typeof LayoutDatenschutzRoute
  '/impressum': typeof LayoutImpressumRoute
  '/inserate': typeof LayoutInserateRoute
  '/kontakt': typeof LayoutKontaktRoute
  '/suche': typeof LayoutSucheRoute
  '/ueber-uns': typeof LayoutUeberUnsRoute
  '/': typeof LayoutIndexRoute
  '/autor/$authorId': typeof LayoutAutorAuthorIdRoute
  '/newsletter/abmelden': typeof LayoutNewsletterAbmeldenRoute
  '/newsletter/verifikation': typeof LayoutNewsletterVerifikationRoute
  '/newsletter': typeof LayoutNewsletterIndexRoute
  '/d/id/$classicId': typeof LayoutDIdClassicIdRouteWithChildren
  '/d/id/$classicId/t/$title': typeof LayoutDIdClassicIdTTitleRoute
}

export interface FileRoutesByTo {
  '/$slug': typeof LayoutSlugRoute
  '/abo': typeof LayoutAboRoute
  '/datenschutz': typeof LayoutDatenschutzRoute
  '/impressum': typeof LayoutImpressumRoute
  '/inserate': typeof LayoutInserateRoute
  '/kontakt': typeof LayoutKontaktRoute
  '/suche': typeof LayoutSucheRoute
  '/ueber-uns': typeof LayoutUeberUnsRoute
  '/': typeof LayoutIndexRoute
  '/autor/$authorId': typeof LayoutAutorAuthorIdRoute
  '/newsletter/abmelden': typeof LayoutNewsletterAbmeldenRoute
  '/newsletter/verifikation': typeof LayoutNewsletterVerifikationRoute
  '/newsletter': typeof LayoutNewsletterIndexRoute
  '/d/id/$classicId': typeof LayoutDIdClassicIdRouteWithChildren
  '/d/id/$classicId/t/$title': typeof LayoutDIdClassicIdTTitleRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/$slug': typeof LayoutSlugRoute
  '/_layout/abo': typeof LayoutAboRoute
  '/_layout/datenschutz': typeof LayoutDatenschutzRoute
  '/_layout/impressum': typeof LayoutImpressumRoute
  '/_layout/inserate': typeof LayoutInserateRoute
  '/_layout/kontakt': typeof LayoutKontaktRoute
  '/_layout/suche': typeof LayoutSucheRoute
  '/_layout/ueber-uns': typeof LayoutUeberUnsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/autor/$authorId': typeof LayoutAutorAuthorIdRoute
  '/_layout/newsletter/abmelden': typeof LayoutNewsletterAbmeldenRoute
  '/_layout/newsletter/verifikation': typeof LayoutNewsletterVerifikationRoute
  '/_layout/newsletter/': typeof LayoutNewsletterIndexRoute
  '/_layout/d/id/$classicId': typeof LayoutDIdClassicIdRouteWithChildren
  '/_layout/d/id/$classicId/t/$title': typeof LayoutDIdClassicIdTTitleRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/$slug'
    | '/abo'
    | '/datenschutz'
    | '/impressum'
    | '/inserate'
    | '/kontakt'
    | '/suche'
    | '/ueber-uns'
    | '/'
    | '/autor/$authorId'
    | '/newsletter/abmelden'
    | '/newsletter/verifikation'
    | '/newsletter'
    | '/d/id/$classicId'
    | '/d/id/$classicId/t/$title'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$slug'
    | '/abo'
    | '/datenschutz'
    | '/impressum'
    | '/inserate'
    | '/kontakt'
    | '/suche'
    | '/ueber-uns'
    | '/'
    | '/autor/$authorId'
    | '/newsletter/abmelden'
    | '/newsletter/verifikation'
    | '/newsletter'
    | '/d/id/$classicId'
    | '/d/id/$classicId/t/$title'
  id:
    | '__root__'
    | '/_layout'
    | '/_layout/$slug'
    | '/_layout/abo'
    | '/_layout/datenschutz'
    | '/_layout/impressum'
    | '/_layout/inserate'
    | '/_layout/kontakt'
    | '/_layout/suche'
    | '/_layout/ueber-uns'
    | '/_layout/'
    | '/_layout/autor/$authorId'
    | '/_layout/newsletter/abmelden'
    | '/_layout/newsletter/verifikation'
    | '/_layout/newsletter/'
    | '/_layout/d/id/$classicId'
    | '/_layout/d/id/$classicId/t/$title'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/$slug",
        "/_layout/abo",
        "/_layout/datenschutz",
        "/_layout/impressum",
        "/_layout/inserate",
        "/_layout/kontakt",
        "/_layout/suche",
        "/_layout/ueber-uns",
        "/_layout/",
        "/_layout/autor/$authorId",
        "/_layout/newsletter/abmelden",
        "/_layout/newsletter/verifikation",
        "/_layout/newsletter/",
        "/_layout/d/id/$classicId"
      ]
    },
    "/_layout/$slug": {
      "filePath": "_layout/$slug.tsx",
      "parent": "/_layout"
    },
    "/_layout/abo": {
      "filePath": "_layout/abo.tsx",
      "parent": "/_layout"
    },
    "/_layout/datenschutz": {
      "filePath": "_layout/datenschutz.tsx",
      "parent": "/_layout"
    },
    "/_layout/impressum": {
      "filePath": "_layout/impressum.tsx",
      "parent": "/_layout"
    },
    "/_layout/inserate": {
      "filePath": "_layout/inserate.tsx",
      "parent": "/_layout"
    },
    "/_layout/kontakt": {
      "filePath": "_layout/kontakt.tsx",
      "parent": "/_layout"
    },
    "/_layout/suche": {
      "filePath": "_layout/suche.tsx",
      "parent": "/_layout"
    },
    "/_layout/ueber-uns": {
      "filePath": "_layout/ueber-uns.tsx",
      "parent": "/_layout"
    },
    "/_layout/": {
      "filePath": "_layout/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/autor/$authorId": {
      "filePath": "_layout/autor/$authorId.tsx",
      "parent": "/_layout"
    },
    "/_layout/newsletter/abmelden": {
      "filePath": "_layout/newsletter/abmelden.tsx",
      "parent": "/_layout"
    },
    "/_layout/newsletter/verifikation": {
      "filePath": "_layout/newsletter/verifikation.tsx",
      "parent": "/_layout"
    },
    "/_layout/newsletter/": {
      "filePath": "_layout/newsletter/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/d/id/$classicId": {
      "filePath": "_layout/d/id/$classicId.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/d/id/$classicId/t/$title"
      ]
    },
    "/_layout/d/id/$classicId/t/$title": {
      "filePath": "_layout/d/id/$classicId/t.$title.tsx",
      "parent": "/_layout/d/id/$classicId"
    }
  }
}
ROUTE_MANIFEST_END */
